import React from "react";
import { listToFirstItemPlus } from "@src/features/home/utils";
import Text from "@src/lib/ui/Text";
import PinsOutlineIcon from "@src/lib/icons/18px/pins-outline";
import IdBadge2OutlineIcon from "@src/lib/icons/18px/id-badge-2-outline";
import Link from "next/link";

type Props = {
  userId: string;
  userName: string;
  locations: string[];
  roles: string[];
};

const UserNameLocationsRolesTableCell: React.FC<Props> = (props) => {
  const locations = React.useMemo(() => {
    return props.locations.length > 0
      ? listToFirstItemPlus(props.locations)
      : "No locations";
  }, [props.locations]);
  const roles = React.useMemo(() => {
    return props.roles.length > 0
      ? listToFirstItemPlus(props.roles)
      : "No roles";
  }, [props.roles]);
  return (
    <Link
      href={{
        pathname: "/users/[id]",
        query: {
          id: props.userId.toString(),
        },
      }}
    >
      <div className="group flex cursor-pointer flex-row items-center gap-2">
        <div className="flex flex-col">
          <Text variant="compact-title" className="group-hover:underline">
            {props.userName}
          </Text>
          <div className="flex flex-row gap-2">
            <div className="flex flex-row items-center gap-1">
              <PinsOutlineIcon className="size-3 text-muted-foreground" />
              <Text
                variant="fine-print-title"
                className="text-muted-foreground"
              >
                {locations}
              </Text>
            </div>
            <Text variant="fine-print-title" className="text-muted-foreground">
              ·
            </Text>
            <div className="flex flex-row items-center gap-1">
              <IdBadge2OutlineIcon className="size-3 text-muted-foreground" />
              <Text
                variant="fine-print-title"
                className="text-muted-foreground"
              >
                {roles}
              </Text>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default UserNameLocationsRolesTableCell;
